// [목적] Day 단위 Fork(day_import) mutation 훅 — 남의 폴리오의 특정 Day 를 내 폴리오로 가져오기
// [이유] FlowLine A8(4c112997): apps/api ForksService.forkDayImport 계약(kind='day_import' +
//        sourceDayIndex + targetPortfolioId) 을 그대로 소비. useForkFolio(kind='full' 고정)와
//        별도 훅으로 분리 — 인자 형태가 달라 하나로 합치면 호출부 타입이 지저분해짐(YAGNI 반대 방향 회피).
// [사이드 이팩트] 성공 시 folio-list 캐시 + 대상 폴리오(targetFolioId) 캐시 invalidate.
// [수정 시 고려사항] 동일 source day 를 같은 target 에 중복 임포트하면 BE 가 409(folio.DAY_IMPORT_CONFLICT) 반환
//                   — 호출부(DayImportDialog)가 이 코드를 안내 문구로 매핑해야 함.

import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { Folio } from '@gangwoncanvas/types';

import { forkFolio } from '../api/folioClient.js';
import { queryKeys } from '../api/queryKeys.js';

interface DayImportArgs {
  sourceFolioId: string;
  sourceDayIndex: number;
  targetFolioId: string;
}

export function useDayImportFolio() {
  const qc = useQueryClient();

  return useMutation<Folio, Error, DayImportArgs>({
    mutationFn: ({ sourceFolioId, sourceDayIndex, targetFolioId }) =>
      forkFolio(sourceFolioId, {
        kind: 'day_import',
        sourceDayIndex,
        targetPortfolioId: targetFolioId,
      }),
    onSuccess: (folio) => {
      void qc.invalidateQueries({ queryKey: ['folio-list'] });
      void qc.invalidateQueries({ queryKey: queryKeys.folio(folio.id) });
    },
  });
}
